export default "__VITE_ASSET__Dg6QsBVJ__"